export function JSONError(response, message, fileName, lineNumber, statusCode) {
  let instance = new Error(message, fileName, lineNumber)
  instance.name = 'JSONError'
  instance.response = response
  instance.statusCode = statusCode

  Object.setPrototypeOf(instance, Object.getPrototypeOf(this))
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, JSONError)
  }
  return instance
}

JSONError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true,
  },
})

function getErrors(json) {
  let errors = []
  for (let key in json) {
    if (key === 'errors') {
      errors = errors.concat(json.errors)
    } else {
      let subErrors = getErrors(json[key])
      if (subErrors.length > 0) {
        errors = errors.concat(subErrors)
      }
    }
  }
  return errors
}

JSONError.prototype.getResponseErrors = function () {
  let errors = []
  if (this.response) {
    if (this.response.errors) {
      errors = errors.concat(getErrors(this.response.errors))
    } else if (this.response.error) {
      errors = errors.concat(this.response.error)
    }
    if (errors.length > 0) {
      return errors
    }
  }
  return undefined
}

JSONError.prototype.getResponseErrorsMessage = function () {
  let errors = this.getResponseErrors()
  let msg = ''
  if (errors) {
    msg = ''
    for (let i = 0; i < errors.length; i++) {
      if (i > 0) {
        msg += '<br>'
      }
      msg += errors[i]
    }
  } else {
    msg = this
  }
  return msg
}

if (Object.setPrototypeOf) {
  Object.setPrototypeOf(JSONError, Error)
} else {
  JSONError.__proto__ = Error
}
